import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Admin.css';

function AdminContacts({ onLogout }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/contact-submissions`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setContacts(data.submissions);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <nav className="admin-nav">
        <div className="admin-nav-content">
          <h1 className="brand-text">ClutchBabe9 Admin</h1>
          <div className="admin-nav-links">
            <Link to="/admin/dashboard" className="admin-nav-link">Dashboard</Link>
            <Link to="/admin/posts" className="admin-nav-link">Posts</Link>
            <Link to="/admin/videos" className="admin-nav-link">Videos</Link>
            <Link to="/admin/subscribers" className="admin-nav-link">Subscribers</Link>
            <Link to="/admin/contacts" className="admin-nav-link active">Contacts</Link>
            <Link to="/admin/profile" className="admin-nav-link">Profile</Link>
            <Link to="/admin/config" className="admin-nav-link">Settings</Link>
            <Link to="/" className="admin-nav-link view-site-link" data-testid="view-site-btn">🌐 View Site</Link>
            <button onClick={() => { onLogout(); navigate('/admin/login'); }} className="btn btn-ghost">Logout</button>
          </div>
        </div>
      </nav>

      <div className="admin-content">
        <h2>Contact Form Submissions</h2>

        {loading ? (
          <div className="loading-spinner"></div>
        ) : (
          <div className="contacts-list">
            {contacts.map(contact => (
              <div key={contact._id} className="contact-card glass-card">
                <div className="contact-header">
                  <h3>{contact.subject}</h3>
                  <span className="contact-date">{new Date(contact.submitted_at).toLocaleString()}</span>
                </div>
                <div className="contact-info">
                  <p><strong>From:</strong> {contact.name} ({contact.email})</p>
                </div>
                <div className="contact-message">
                  <p>{contact.message}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminContacts;
